import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { EmployeesTab } from '../components/admin/EmployeesTab';
import { PartsTab } from '../components/admin/PartsTab';

const AdminManagement = () => {
  const [employees, setEmployees] = useState([]);
  const [parts, setParts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [empRes, partsRes] = await Promise.all([
        axios.get(`${API}/employees`),
        axios.get(`${API}/parts`)
      ]);
      setEmployees(empRes.data);
      setParts(partsRes.data);
    } catch {
      toast.error('Грешка при зареждане на данни');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b-2 border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-5 flex items-center gap-3">
          <Button
            data-testid="back-button"
            onClick={() => navigate('/admin')}
            variant="outline"
            size="sm"
            className="border-2 shrink-0"
          >
            <ArrowLeft className="w-4 h-4" />
          </Button>
          <h1 className="heading-font text-base sm:text-2xl md:text-3xl font-bold text-slate-900 uppercase truncate">
            Управление на данни
          </h1>
        </div>
      </div>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto p-3 sm:p-4 md:p-8">
        <Tabs defaultValue="employees" className="w-full">
          <TabsList className="grid grid-cols-2 w-full max-w-md mb-4 sm:mb-6">
            <TabsTrigger value="employees" className="uppercase text-xs py-2">Служители</TabsTrigger>
            <TabsTrigger value="parts" className="uppercase text-xs py-2">Детайли</TabsTrigger>
          </TabsList>

          <TabsContent value="employees">
            <EmployeesTab employees={employees} loadData={loadData} />
          </TabsContent>

          <TabsContent value="parts">
            <PartsTab parts={parts} loadData={loadData} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminManagement;
